import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

const noImageAvailableMap: { [key: string]: string } = {
  lastminute: 'no_hotel_image_placeholder_pink.svg',
  weg: 'no_hotel_image_placeholder_orange.svg',
  rumbo: 'no_hotel_image_placeholder_pink.svg',
  volagratis: 'no_hotel_image_placeholder_pink.svg',
};

export function usePlaceholderImage(): string {
  const { staticData } = usePageWrapperData();

  return (
    noImageAvailableMap[staticData.domainValues?.coreBrand?.toLowerCase() || 'lastminute'] ||
    'no_hotel_image_placeholder_pink.svg'
  );
}
